import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { EndCustomer } from '../api/models';
import { EndCustomersService } from '../api/services';

@Injectable()
export class EndCustomerPeerService {

  private endCustomer: ReplaySubject<EndCustomer>;
  private state: ReplaySubject<string>;

  constructor(private endCustomersService: EndCustomersService) {
    this.endCustomer = new ReplaySubject<EndCustomer>(1);
    this.state = new ReplaySubject<string>(1);
  }

  initialize(id: number) {
    if (id) {
      this.endCustomersService.getEndCustomer({id: id}).subscribe((endCustomer: EndCustomer) => {
        this.endCustomer.next(endCustomer);
      });
    }
  }

  get(): Observable<EndCustomer> {
    return this.endCustomer.asObservable();
  }

  getState(): Observable<string> {
    return this.state.asObservable();
  }

  create(): void {
    this.endCustomer.next(<EndCustomer>{});
  }

  lock(): void {
    this.state.next('locked');
  }

  unlock(): void {
    this.state.next('unlocked');
  }

  refresh(): void {
    this.get().pipe(take(1)).subscribe((endCustomer) => {
      this.initialize(endCustomer.id)
    });
  }

  save(endCustomer: EndCustomer): void {
    let createOrUpdate: Observable<EndCustomer>;
    if (endCustomer.id) {
      createOrUpdate = this.endCustomersService.updateEndCustomer({id: endCustomer.id, body: endCustomer})
    } else {
      createOrUpdate = this.endCustomersService.createEndCustomer({body: endCustomer})
    }

    createOrUpdate.subscribe((updated: EndCustomer) => {
      this.endCustomer.next(updated);
      this.state.next('unlocked');
    });
  }

}
